import api from "@/services/api";

const _http = {
  async getAll(params) {
    return api.get("/specification", { params });
  },
  async create(data) {
    return api.post("/specification", data);
  },
  async update(id, data) {
    return api.put(`/specification/${id}`, data);
  },

  async updateStatus(id, is_active) {
    return api.put(`/specification/${id}/status`, { is_active });
  },
};




export default {
    async getAll(params) {
        try {
            const res = await _http.getAll(params);
            return {
                data: (res.data.data || []).map((item) => item),
                total: res.data.total || 0,
            };
        } catch (error) {
            console.error(error);
            return { data: [], total: 0 };
        }
    },
    async create (payload) {
        try {
            const response = await _http.create(payload);
            return response.data;
        } catch (error) {
            console.error("Error creating device specification:", error);
            throw error;
        }
    },
    async update (id, payload) {
        try {
            const response = await _http.update(id, payload);
            return response.data;
        } catch (error) {
            console.error("Error updating device specification:", error);
            throw error;
        }
    },
    async updateStatus (id, status) {
        try {
            const response = await _http.updateStatus(id, status);
            return response.data;
        } catch (error) {
            console.error("Error updating device specification status:", error);
            throw error;
        }
    },
};
